import React, { useState, useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { removeAccount } from "bodycodi/cmap/app/js/common";

// common
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

// assets
import CheckOn from "bodycodi/cmap/app/img/checkbox-round-on.svg";
import CheckOff from "bodycodi/cmap/app/img/checkbox-round-off.svg";

const RemoveAccountPop = () => {
  const [checked, setChecked] = useState(false);
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "REMOVE_ACCOUNT_POP", open: { removeAccountPop: false } });
    setChecked(false);
  };

  return (
    <CustomDialog open={state.removeAccountPop} onClose={handleClose}>
      <PopupHeader title="바디코디 강사앱 탈퇴" onClickBack={handleClose} />

      <div className="remove-account">
        <div>
          <div className="title">탈퇴 전 꼭 확인해주세요!</div>

          <div className="terms-wrapper">
            <p>바디코디 강사앱을 탈퇴하면,</p>
            <div className="term">
              탈퇴 시 일부 개인정보는 개인정보처리방침에 따라 즉시 삭제하며, 삭제된 정보는 복구할 수
              없습니다. 관계법령에 필요한 정보일 경우 일정 기간 별도 보관합니다.
            </div>

            <div className="term">
              회원가입 이후 커뮤니티에 등록한 모든 게시물은 탈퇴 후에도 삭제 되지 않고 유지됩니다.
            </div>

            <div className="term">
              강사앱을 탈퇴하더라도 모바일 강사앱 가입 시 등록한 개인정보는 즉시 삭제되지만,
              바디코디 회원관리 프로그램에서 등록된 임직원 정보는 삭제되지 않습니다. 해당 정보는
              센터에 개별 문의해 주세요.
            </div>
          </div>
        </div>

        <div className="bottom-box">
          <div className="checkbox-wrapper" onClick={() => setChecked((prev) => !prev)}>
            <img src={checked ? CheckOn : CheckOff} />
            <span>위 내용을 모두 이해하였으며 동의합니다.</span>
          </div>
          <button disabled={!checked} onClick={removeAccount}>
            강사앱 탈퇴하기
          </button>
        </div>
      </div>
    </CustomDialog>
  );
};

export default RemoveAccountPop;
